import { createSlice } from "@reduxjs/toolkit";





export const makeSsrUiKey = ({ swtName, location, machine, id }) =>
  `${swtName}|${location}|${machine}|${id}`;



export const EMPTY_SSR_UI = Object.freeze({
  isSettingOpen: false,
  openPasswordBox: false,
});

const initialState = {};

const ensureEntry = (state, key) => {
  if (!state[key]) {
    state[key] = { isSettingOpen: false, openPasswordBox: false };
  }
  return state[key];
};

const ssrUiSlice = createSlice({
  name: "ssrUi",
  initialState,
  reducers: {
    setSsrSettingOpen: (state, action) => {
      const { status, ...keyParams } = action.payload;
      ensureEntry(state, makeSsrUiKey(keyParams)).isSettingOpen = status;
    },
    setSsrPasswordBox: (state, action) => {
      const { status, ...keyParams } = action.payload;
      ensureEntry(state, makeSsrUiKey(keyParams)).openPasswordBox = status;
    },
  },
});

export const selectSsrUiEntry = (state, keyParams) =>
  state.ssrUi[makeSsrUiKey(keyParams)] || EMPTY_SSR_UI;

export const { setSsrSettingOpen, setSsrPasswordBox } = ssrUiSlice.actions;

export default ssrUiSlice;
